import { ActDomainFormVM } from 'civil-status/view-models/act-domain-form';
import { ActValueDomainVM } from 'civil-status/view-models/act-value-domain-managment-list';
import { DateTime } from 'luxon';
export const transformRequestActDomain = (values: ActDomainFormVM) =>
  ({
    key: {
      codEnte: values?.entityBody || undefined,
      idDominio: values?.domainType ? Number(values?.domainType) : undefined,
    },
    nomeDominio: values?.domainName || undefined,
    noteUtilizzo: values?.usageNote || undefined,
    valoriDominio:
      values?.actDomainValues?.map((item: ActValueDomainVM) => ({
        key: {
          codEnte: item?.entityBody || undefined,
          idDominio: item?.domainType ? Number(item?.domainType) : undefined,
          idValore: item?.value || undefined,
        },
        idValoreAnsc: item?.valueAnsc || undefined,
        descrizioneBreveValore: item?.shortDescription || undefined,
        valore: item?.description || undefined,
        descrizioneArticoloAnteposto: item?.precedingArticle || undefined,
        codiceGenere: item?.type || undefined,
        codiceStatistico: item?.statisticCode || undefined,
        autorizzazioneArticoloLegge: item?.lawAuthorizeArticle || undefined,
        dataInizioValidita: item?.startValidityDate
          ? DateTime.fromFormat(item?.startValidityDate, 'dd/MM/yyyy').toISODate()
          : undefined,
        dataFineValidita: item?.endValidityDate
          ? DateTime.fromFormat(item?.endValidityDate, 'dd/MM/yyyy').toISODate()
          : undefined,
        numOrdinamento: item?.displayOrderNumber ? Number(item?.displayOrderNumber) : undefined,
        tipoDominioPadre: item?.fatherDomainType ? Number(item?.fatherDomainType) : undefined,
        idValorePadre: item?.fatherDomainValue || undefined,
      })) || undefined,
  } as const);
